import { useState, createContext, useEffect } from "react";
import useForm from "../hooks/useForm";

// create context
const AppContext = createContext({});

// context provider
const AppProvider = ({ children }) => {
  const [user, setUser] = useState({});

  useEffect(() => {
    setUser({
      userName: localStorage.getItem("userName"),
      userId: localStorage.getItem("uid"),
    });
  }, [localStorage]);

  const value = { user, setUser };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export { AppContext, AppProvider };
